import {
  loadAppearance,
  saveAppearance,
  applyAppearance,
  defaultAppearance
} from '@/lib/utils/appearance'

export const state = {
  ...loadAppearance()
}

export const getters = {
  theme: (s) => s.theme,
  fontFamily: (s) => s.fontFamily,
  fontSize: (s) => s.fontSize,
  customColors: (s) => s.customColors,
  appearance: (s) => ({
    theme: s.theme,
    fontFamily: s.fontFamily,
    fontSize: s.fontSize,
    customColors: s.customColors
  })
}

export const mutations = {
  SET_THEME(s, v) {
    s.theme = v
  },
  SET_FONT_FAMILY(s, v) {
    s.fontFamily = v
  },
  SET_FONT_SIZE(s, v) {
    s.fontSize = v
  },
  SET_CUSTOM_COLOR(s, { mode, key, value }) {
    const next = {
      light: { ...s.customColors.light },
      dark: { ...s.customColors.dark }
    }
    if (value) next[mode][key] = value
    else delete next[mode][key]
    s.customColors = next
  },
  RESET_CUSTOM_COLORS(s, mode) {
    s.customColors = {
      light: { ...s.customColors.light },
      dark: { ...s.customColors.dark },
      [mode]: {}
    }
  },
  RESET_ALL(s) {
    s.theme = defaultAppearance.theme
    s.fontFamily = defaultAppearance.fontFamily
    s.fontSize = defaultAppearance.fontSize
    s.customColors = { light: {}, dark: {} }
  }
}

function persistAndApply(state) {
  saveAppearance(state)
  applyAppearance(state)
}

export const actions = {
  // Apply the persisted settings to the DOM (call once on app start).
  init({ state }) {
    applyAppearance(state)
  },
  setTheme({ commit, state }, value) {
    commit('SET_THEME', value)
    persistAndApply(state)
  },
  setFontFamily({ commit, state }, value) {
    commit('SET_FONT_FAMILY', value)
    persistAndApply(state)
  },
  setFontSize({ commit, state }, value) {
    commit('SET_FONT_SIZE', value)
    persistAndApply(state)
  },
  setCustomColor({ commit, state }, payload) {
    commit('SET_CUSTOM_COLOR', payload)
    persistAndApply(state)
  },
  resetCustomColors({ commit, state }, mode) {
    commit('RESET_CUSTOM_COLORS', mode)
    persistAndApply(state)
  },
  resetAll({ commit, state }) {
    commit('RESET_ALL')
    persistAndApply(state)
  }
}
